module.exports = ".detailsClass {\r\n\tfloat:left;\r\n\tborder-top: 1px solid #000;\r\n\tmin-height:25px;\r\n}\r\n\r\n.detailRow {\r\n\twidth:310px;\r\n\tfloat:left;\r\n\tmargin-bottom:2px;\r\n\tpadding:2px;\r\n}\r\n\r\n.detailLabel {\r\n\tfont-weight: bold;\r\n\tfloat:left;\r\n\twidth: 150px;\r\n}\r\n\r\n.detailInfo {\r\n\tfloat:left;\r\n\twidth: 150px;\t\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory-manager/view-inventory/view-inventory.component.css
// module id = ./src/app/inventory-manager/view-inventory/view-inventory.component.css
// module chunks = main